<template>
  <transition name="bounce">
    <div class="kiko-confirm" v-if="visible">
      <div class="bg"></div>
      <div class="kiko-container" :style="{width: width}">
        <div class="header">
          {{title}}
          <i @click="close" class="icon-remove icon-large kiko-close-btn" v-if="closeVisible"></i>
        </div>
        <div class="contents">
          {{content}}
        </div>
        <div class="kiko-footer">
          <a class="kiko-btn make-sure" @click="confirm" id="confirm">{{sureText}}</a>
          <a class="kiko-btn cancel" @click="close" v-if="showCancelBtn">{{cancelText}}</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
  /*
  * 使用模板的方式调用
  * 1.引用模板 import vConfirm from './../utils/confirm.vue'
  * 2.注册模板 compontents:{vConfirm}
  * 3.页面标签调用
  *<v-confirm :visible="show" @cancel="cancel" @confirm="confirm" :showCancelBtn="false">
  *   这里是我们可以传入自定义的内容
  *   <span slot="content">测试confirm</span>
  *</v-confirm>
  *4.传参和默认值：
  *   visible: 布尔值，默认为false，模态框是否显示
  *   width: 模态框的宽度，默认为'260px',//传入字符串样式-> '260px'
  *   showCancelBtn: 布尔值，默认为true， 是否显示关闭按钮
  *   @cancel:用户点击关闭按钮调用的函数
  *   @confirm：用户点击确认按钮触发的函数
  *   @content: 文本，没有主题的时候可以使一句话
  *
  *
   */

  export default {
    name: 'confirm',
    props: {
      width: {type: String, default: '400px'},
      title: {type: String, default: '信息'},
      content: {type: String, default: '内容'},
      cancelText:{type:String,default:'取消'},
      sureText:{type:String,default:'确定'},
      visible: {type: Boolean, default: true},
      closeVisible: {type: Boolean, default: true},
      showCancelBtn:{type: Boolean, default: true},
    },
    data () {
      return {
        callback:null
      }
    },
    methods: {
      close () {
        // 这个事件在使用模板调用的时候调用
        this.$emit('cancel', false);
        // 这个事件是通过this.$comfirm调用的时候调用
        this.closeConfirm && this.closeConfirm();
      },
      confirm(){
        // 这个事件在使用模板调用的时候调用
        this.$emit('confirm', false);
        // 这个事件是通过this.$comfirm调用的时候调用
        this.submitConfirm && this.submitConfirm();
      },
    }
  }
</script>
<style scoped>


  .kiko-confirm {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999;
  }
  .kiko-confirm .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0.3;
    z-index: 99999;
  }
  .kiko-confirm .kiko-container {
    position: absolute;
    display: inline-block;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 260px;
    min-width: 260px;
    z-index: 9999999999999;
  }
  .header {
    width: 100%;
    padding: 10px;
    background-color: #4575A6;
    border-bottom: 1px solid #eee;
    color: #fff;
    text-align: left;
  }
  .contents {
    width: 100%;
    padding: 10px;
    background-color: #FFFFFF;
    text-align: center;
  }
  .kiko-footer {
    width: 100%;
    padding: 10px;
    background-color: #FFFFFF;
    text-align: right;
    border-top: 1px solid #eee;
  }
  .kiko-btn {
    padding: 5px 15px;
    text-decoration: none !important;
    border-radius: 2px;
    margin: 6px 6px 0 6px;
  }
  .kiko-btn:hover {
    text-decoration:  none !important;
  }
  .kiko-btn:active {
    text-decoration:  none !important;
  }
  .kiko-btn.make-sure {
    background-color: #4575A6;
    color: #fff;
  }
  .kiko-btn.cancel {
    background-color: #BBB5B5;
    color: #fff;
  }
  .kiko-close-btn {
    cursor: pointer;
    float: right;
  }
  .hidden {
    transform: scale(0);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/confirm.vue